import api from "!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[10].use[1]!../node_modules/@angular-devkit/build-angular/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[10].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[10].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[10].use[4]!./styles.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};